import { render, staticRenderFns } from "./referencia.vue?vue&type=template&id=626d676b&scoped=true&"
import script from "./referencia.vue?vue&type=script&lang=ts&"
export * from "./referencia.vue?vue&type=script&lang=ts&"
import style0 from "./referencia.vue?vue&type=style&index=0&id=626d676b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626d676b",
  null
  
)

export default component.exports